const MOTUS = {
  FILER_NUMBER: "5008013",
  LEGAL_BUSINESS_NAME: "United Carrier Route Compliance",
  EMAIL: "assistant@truck-ai.com",
  PHONE: "+1 (747) 305-2373",
  ADDRESS: "6817 Foothill Blvd, Tujunga, CA 91042-2710",
  CAPABILITY: "Transportation Service Provider",
  STATUS: "Active",
};

export default MOTUS;
